import React from 'react';
import { useSelector } from 'react-redux';

import { getPermissionDeniedKey } from 'constants/Global';

import { isOpenPermissionModal } from 'modules/notifications/selectors/ui';
import { getCurrentUserId } from 'modules/users/selectors/currentUser';

export const getLocalStoragePermissionDenied = userId => {
  const localStorageKey = getPermissionDeniedKey(userId);
  return localStorage.getItem(localStorageKey) === 'true';
};

const useNotificationPermission = () => {
  const userId = useSelector(getCurrentUserId);
  const isNotificationModalVisible = useSelector(isOpenPermissionModal);

  const [hasUserDenied, setUserDenied] = React.useState(false);

  React.useEffect(() => {
    setUserDenied(getLocalStoragePermissionDenied(userId));
  }, [userId, isNotificationModalVisible]);

  return { hasUserDenied };
};

export default useNotificationPermission;
